import { GridEmissionsDto } from "@flexidao/dto";
import * as D from "schemawax";
import { isoTimestampDecoder } from "../utils";

export const hourlyIntensitiesResponseDecoder: D.Decoder<
    Record<string, Array<GridEmissionsDto.ZoneIntensityDto>>
> = D.record(
    D.array(
        D.object({
            required: {
                endTime: isoTimestampDecoder,
                startTime: isoTimestampDecoder,
                gridIntensity: D.number,
                cfeShare: D.number,
                reShare: D.number,
                totalProduction: D.number,
            },
        }),
    ),
);

export const zonesEmissionsRatesResponseDecoder: D.Decoder<Array<GridEmissionsDto.EmissionRate>> =
    D.array(
        D.object({
            required: {
                zoneId: D.string,
                year: D.number,
                rateId: D.string,
                value: D.number,
            },
        }),
    );
